export const Adviser = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 11H9C8 11 8 12 8 12V16C8 16 8 17 9 17H16C16.9999 17 16.9999 16 16.9999 16V12C16.9999 12 16.9999 11 16 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17V9.91429C14 9.6718 13.9157 9.43925 13.7657 9.26779C13.6157 9.09633 13.4122 9 13.2 9H11.8C11.5878 9 11.3843 9.09633 11.2343 9.26779C11.0843 9.43925 11 9.6718 11 9.91429V17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.875 7.5C7.66993 7.5 9.125 6.04493 9.125 4.25C9.125 2.45507 7.66993 1 5.875 1C4.08007 1 2.625 2.45507 2.625 4.25C2.625 6.04493 4.08007 7.5 5.875 7.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4 9L6 12L8 9" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M8 9H3.89956C3.13055 9 2.39304 9.30549 1.84926 9.84926C1.30549 10.393 1 11.1306 1 11.8996V17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
